import { createAction, props } from "@ngrx/store";
import { IDetalleTema, IIndicacionAB } from "../../interfaces/temas";
import {
  IAcuerdo,
  IAcuerdoSeleccionado,
  IArchivoAcuerdo,
  IEntregablesArchivosEntrada,
} from "../../interfaces/acuerdos";
import { INuevaEntrada } from "../../interfaces/entradas";
import { IArchivoAdjunto } from "../../interfaces/storage";

export const cargaTemasAcuerdo = createAction(
  "[Temas Component] cargaTemasAcuerdo",
  props<{ acuerdoSeleccionado: IAcuerdoSeleccionado }>()
);

export const eliminarTemaMrb = createAction(
  "[Temas Component] eliminarTemaMrb",
  props<{ temaStatus: string }>()
);
export const nuevosArchivosAcuerdo = createAction(
  "[Temas Component] nuevo archivo Acuerdo",
  props<{ files: IArchivoAcuerdo[] }>()
);

export const eliminarArchivoAcuerdo = createAction(
  "[Temas Component] eliminaar archivo cuerdo",
  props<{ file: IArchivoAcuerdo }>()
);

export const agregarNuevoTema = createAction(
  "[Temas Component] agregarNuevoTema",
  props<{ tema: IDetalleTema }>()
);

export const toggleExpandTema = createAction(
  "[Temas Component] Toggle Expand Tema",
  props<{ id: string }>()
);

export const resetTemasAcuerdo = createAction(
  "[Temas Component] resetTemasAcuerdo"
);

export const resetTemasDejarAcuerdo = createAction(
  "[Temas Component] resetTemasDejarAcuerdo",
  props<{ acuerdo: IAcuerdo }>()
);

export const updateTemaForm = createAction(
  "[Temas Component] update Tema Form",
  props<{ id: number; formValue: any }>()
);

export const dragArchivosTema = createAction(
  "[Acuerdos Component] drag archivosTema",
  props<{ idTema: string; idEntrada: string; archivos: any[] }>()
);

export const dragEntrregablesTema = createAction(
  "[Acuerdos Component] drag  entregable tema",
  props<{ idTema: string; idEntrada: string; entregables: any[] }>()
);

export const dragEntrada = createAction(
  "[Acuerdos Component] drag entrada",
  props<{ idTema: string; entradas: any[] }>()
);

export const agregarNuevaEntrada = createAction(
  "[Acuerdos Component] agregar Nueva Entrada"
);
export const agregarNuevaEntradaSuccess = createAction(
  "[Acuerdos Component] agregar NuevaEntrada Success",
  props<{ temaId: string; entrada: INuevaEntrada }>()
);
export const cargar = createAction(
  "[Acuerdos Component] agregar NuevaEntrada Fail"
);

export const cargarEntregablesArchivos = createAction(
  "[Acuerdos Component] cargar Entregables Archivos",
  props<{ idEntrada: string }>()
);
export const cargarEntregablesArchivosError = createAction(
  "[Acuerdos Component] cargar Entregables Archivos Error"
);
export const cargarEntregablesArchivosSuccess = createAction(
  "[Acuerdos Component] cargar Entregables Archivos Success",
  props<{ archivosEntregables: IEntregablesArchivosEntrada }>()
);

export const agregarNuevaEntradaFail = createAction(
  "[Acuerdos Component] agregar NuevaEntrada Fail"
);

export const nuevoActualizarIndicacion = createAction(
  "[Acuerdos Component] nuevo Actualizar Indicacion",
  props<{ indicacion: IIndicacionAB }>()
);

export const eliminarArchivoAdjunto = createAction(
  "[Acuerdos Component] eliminar Archivo Adjunto",
  props<{ idTema: string; archivo: IArchivoAdjunto }>()
);

export const eliminarEntrada = createAction(
  "[Acuerdos Component] eliminar Entrada ",
  props<{ entrada: INuevaEntrada }>()
);

export const agregarEditarObservacionesAcuerdo = createAction(
  "[Nuevo Tema Component] agregarEditar Observaciones Acuerdo ",
  props<{ observaciones: string }>()
);

export const realizarAcuerdo = createAction(
  "[Nuevo Tema Component] se lleva acabo acuerdo",
  props<{ esRealizado: boolean }>()
);

export const updateFechaAcuerdo = createAction(
  "[Acuerdos Component] update Fecha Acuerdo",
  props<{ fecha: string; acuerdo: IAcuerdo }>()
);

export const updateEliminarTemaMrb = createAction(
  "[Acuerdos Component] updateEliminarTemaMrb",
  props<{
    temas: IDetalleTema[];
    idAcuerdo: number;
  }>()
);
